import type { SignupScreen } from './CreateAccountFormContext';
import type { SignupInvite } from './hooks/useInvite';
import {
  isAccountUnderReviewError,
  isEmailNotVerifiedError,
} from './signupUtils';

type DeriveSignupScreenOptions = {
  isLoading: boolean;
  isAuthenticated: boolean;
  invite?: SignupInvite;
  currentUserEmail?: string;
  isEmailVerified: boolean;
  submissionError?: Error;
  authError?: Error;
};

export const deriveSignupScreen = ({
  isLoading,
  isAuthenticated,
  invite,
  currentUserEmail,
  isEmailVerified,
  submissionError,
  authError,
}: DeriveSignupScreenOptions): SignupScreen => {
  const inviteEmail = invite?.email.trim() || undefined;
  const hasInviteEmailMismatch =
    invite !== undefined &&
    (!inviteEmail ||
      currentUserEmail?.toLowerCase() !== inviteEmail.toLowerCase());

  if (isLoading) return 'loading';
  if (isAuthenticated && hasInviteEmailMismatch) {
    return 'invite_email_mismatch';
  }
  if (isAuthenticated && !isEmailVerified) return 'verify_email';
  if (isAuthenticated && isAccountUnderReviewError(submissionError)) {
    return 'under_review';
  }
  if (isAuthenticated) return 'workspace_setup';
  if (isEmailNotVerifiedError(authError)) return 'login_verify_email';
  return 'welcome';
};
